import React from "react";
import {ResponsiveBar} from "@nivo/bar";
import {useColorMode} from "@chakra-ui/react";
import Loading from "components/Loading/Loading";
import {singleColorChart} from "variables/colors";
import {margin, padding} from "variables/nivo/bar";
import {useDemographicDash} from "hooks/demographicDash";
import {axisBottom, axisLeft, labelTextColor, themeDark, themeLight, tooltip} from "variables/nivo/default";

const BodyMassChart = () => {
    const { isLoadingCustomersBodyMass: isLoading, dash_val: data } = useDemographicDash();
    
    const { colorMode } = useColorMode();

    if (!isLoading && !!data && !!data.imc_amount_by_partner) {
        return (
            <ResponsiveBar
                data={data.imc_amount_by_partner}
                keys={["quant"]}
                indexBy="name"
                layout="vertical"
                margin={margin}
                padding={padding}
                colors={singleColorChart}
                theme={colorMode === "light" ? themeLight : themeDark}
                axisBottom={axisBottom}
                axisLeft={axisLeft}
                labelSkipHeight={11}
                labelTextColor={labelTextColor}
                tooltip={({indexValue, value}) => tooltip(indexValue, value)}
            />
        )
    }

    return <Loading/>;
};

export default BodyMassChart
